import { combineReducers, configureStore } from '@reduxjs/toolkit';
import config from './config';
import apiSlice from '../features/api/rest/apiSlice';
import apiFoodFactsSlice from '../features/api/openFoodFacts/apiFoodFactsSlice';
import scannerSlice from '../features/scannerSlice';
import cameraSlice from '../features/cameraSlice';
import layoutSliceReducer from '../features/layoutSlice';
import imagesReviewReducer from '../features/imagesReviewSlice';
import qrCodeFiltersSlice from '../features/qrCodeFilters';

const rootReducer = combineReducers({
  [apiSlice.reducerPath]: apiSlice.reducer,
  [apiFoodFactsSlice.reducerPath]: apiFoodFactsSlice.reducer,
  layout: layoutSliceReducer,
  scanner: scannerSlice,
  camera: cameraSlice,
  imagesReview: imagesReviewReducer,
  qrCodeFilters: qrCodeFiltersSlice.reducer,
});

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['imagesReview/add'],
        ignoredPaths: ['imagesReview.imagesArray'],
      },
    }).concat([apiSlice.middleware, apiFoodFactsSlice.middleware]),
  devTools: config.debug,
});

export default store;
